<template>
  <el-container class="management">
    <div class="mg-header">
      <AFHeader
        ref="afheader"
        :tab="tab_ch"
        @toggletab="change_tab"
      />
    </div>
    <el-main>
      <soft-manage v-if="tab === 0" />
      <exp-manage v-if="tab === 1" />
      <data-manage v-if="tab === 2" />
      <monitor-manage v-if="tab === 3 && isDice" />
    </el-main>
  </el-container>
</template>

<script>
import AFHeader from '../components/header'
import softManage from './soft-manage'
import expManage from './exp-manage'
import dataManage from './data-manage'
import monitorManage from './monitor-manage'

export default {
  components: {
    AFHeader,
    softManage,
    expManage,
    dataManage,
    monitorManage
  },
  filters: {
    format_time (sec) {
      const ft = new Date(sec)

      const y = ft.getFullYear()
      const m = ft.getMonth() + 1
      const d = ft.getDate()
      const h = ft.getHours()
      const ms = ft.getMinutes()
      const s = ft.getSeconds()

      const formatNum = num => {
        if (num < 10) {
          return '0' + num
        }
        return num
      }

      return y + '-' + formatNum(m) + '-' + formatNum(d) + ' ' + formatNum(h) + ':' + formatNum(ms) + ':' + formatNum(s)
    }
  },
  data () {
    return {
      detail: null,
      tab: 0,
      tab_ch: ['应用管理', '实例管理', '数据管理'],
      data: {},
      app_detail: {}// 头部信息
    }
  },
  computed: {
    isDice () {
      return location.href.indexOf('dice') > -1
    }
  },
  beforeRouteEnter (to, from, next) {
    if (from.fullPath.includes('formflow/workbench')) {
      next(vm => {
        if (vm.$route.query.tab && vm.$route.query.tab === 2) {
          vm.tab = 2
          vm.$refs.afheader.currentTab = '数据管理'
        }
      })
    }
    next()
  },
  created () {
    if (this.isDice) {
      this.tab_ch.push('统计监控')
    }
  },
  methods: {
    change_tab (item, index) {
      this.tab = index
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
@mixin flex-column {
  display: flex !important;
  flex-direction: column !important;
}
* {
  font-family: PingFangSC-Medium, PingFangSC;
  padding: 0;
  margin: 0;
}
.management {
  @include flex-column;
  height: 100%;
  min-width: 880px;
  .mg-header {
    background: #fff;
    box-shadow: 0px 2px 10px 0px rgba(39, 56, 70, 0.1);
    margin-bottom: 20px;
  }
  .el-main {
    width: 100%;
    flex-grow: 0 !important;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 10px 0px rgba(39, 56, 70, 0.1);
  }
}
</style>
